/**
 * @generated SignedSource<<cc7f4ec738fea8bf98b504df58f93065>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productBackgroundSectionQuery$variables = Record<PropertyKey, never>;
export type productBackgroundSectionQuery$data = {
  readonly generalSettings: {
    readonly isSideImageScalingEnabled: boolean;
  };
  readonly resizableBackgroundPresets: ReadonlyArray<{
    readonly imageUrl: string;
    readonly name: string;
    readonly presetID: number;
    readonly thumbnailUrl: string;
  }>;
  readonly seller: {
    readonly sellerID: number;
  } | null;
};
export type productBackgroundSectionQuery = {
  response: productBackgroundSectionQuery$data;
  variables: productBackgroundSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presetID",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerID",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSideImageScalingEnabled",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "productBackgroundSectionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ResizableBackgroundPreset",
        "kind": "LinkedField",
        "name": "resizableBackgroundPresets",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Seller",
        "kind": "LinkedField",
        "name": "seller",
        "plural": false,
        "selections": [
          (v4/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GeneralSettings",
        "kind": "LinkedField",
        "name": "generalSettings",
        "plural": false,
        "selections": [
          (v5/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "productBackgroundSectionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ResizableBackgroundPreset",
        "kind": "LinkedField",
        "name": "resizableBackgroundPresets",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Seller",
        "kind": "LinkedField",
        "name": "seller",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GeneralSettings",
        "kind": "LinkedField",
        "name": "generalSettings",
        "plural": false,
        "selections": [
          (v5/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "07529f209520beff4817bff77a7b3625",
    "id": null,
    "metadata": {},
    "name": "productBackgroundSectionQuery",
    "operationKind": "query",
    "text": "query productBackgroundSectionQuery {\n  resizableBackgroundPresets {\n    presetID\n    name\n    imageUrl\n    thumbnailUrl\n    id\n  }\n  seller {\n    sellerID\n    id\n  }\n  generalSettings {\n    isSideImageScalingEnabled\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d638f6676bc5ddeab7e7dc002c03d283";

export default node;
